import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { CharacterListEntry } from './CharacterListEntry.js';
export function CharacterDropDown(props) {
    const { characters, selection, changeSelection, label, size = 'medium' } = props;
    const characterById = new Map();
    for (const character of characters) {
        characterById.set(character.id, character);
    }
    const handleChange = (event) => {
        const selectedId = event.target.value;
        const selectedCharacter = characterById.get(selectedId);
        if (selectedCharacter) {
            changeSelection(selectedCharacter);
        }
    };
    return (_jsxs(FormControl, { fullWidth: true, size: size, children: [label && _jsx(InputLabel, { id: "character-dropdown-label", children: label }), _jsx(Select, { value: selection?.id ?? '', labelId: label ? 'character-dropdown-label' : undefined, label: label, onChange: handleChange, renderValue: (selectedId) => {
                    const character = characterById.get(selectedId);
                    return character?.name ?? '';
                }, children: characters.map((character) => (_jsx(MenuItem, { value: character.id, children: _jsx(CharacterListEntry, { character: character, button: false, dense: true }) }, character.id))) })] }));
}
//# sourceMappingURL=CharacterDropDown.js.map